import { createFileRoute } from '@tanstack/react-router'

import { OnlineSalesReport } from '@/components/reports/online-sales/online-sales-report'
import { ReportPage } from '@/components/reports/report-page'
import { m } from '@/lib/paraglide/messages'
import { requireShopEnabled } from '@/lib/shop-module'
import { queryClient } from '@/router'

// Báo cáo › Zalo Mini App (hợp đồng v3 §14.7, wireframe ErpBaoCaoMiniApp).
export const Route = createFileRoute(
    '/_app/_authed/_sidebar/reports/zalo-mini-app',
)({
    // Báo cáo kênh bán lẻ: chỉ khi SHOP_ENABLED (như menu + API).
    beforeLoad: () => requireShopEnabled(queryClient),
    component: MiniAppReportPage,
})

function MiniAppReportPage() {
    return (
        <ReportPage title={m.online_report_title_miniapp()}>
            <OnlineSalesReport channel="zalo_mini_app" />
        </ReportPage>
    )
}
